<template>
  <div style="height:100%">
    <div class="search-wrapper">
      <div>
        <span>责任中心：</span>
        <Select v-model="searchName" style="width: 150px;margin-right:20px;">
          <Option
            v-for="depart in areaArr"
            :key="depart.id"
            :value="depart['name']"
          >{{depart['name']}}</Option>
        </Select>
        <span>业务人员:</span>
        <Input style="width:150px;margin:5px 10px;" type="text" v-model="searchName" />
        <span>资金及费用类型：</span>
        <Input v-model="searchName" style="width:150px;margin-right:20px;"></Input>
        <Button type="primary" @click="search" style="margin-right:10px">搜索</Button>
        <Button type="primary" @click="addPVisible=true" style="margin-right:10px">新增</Button>
      </div>
    </div>
    <Table :columns="columns" :data="tableData" style="min-width:1000px"></Table>
    <Page
      :total="pageTotal"
      :current="pageNum"
      :page-size="pageSize"
      show-elevator
      show-total
      style="margin-top:5px;"
      @on-change="pageChange"
    ></Page>
    <Modal v-model="addPVisible" title="双周资金计划申请" width="900" :mask-closable="false" @on-ok="createPlan">
      <Form inline :label-width="110">
        <table border="1" style="width:100%;border-collapse:collapse;table-layout:fixed">
          <tr>
            <td style="width:25%">
              责任中心：
            </td>
            <td style="width:25%">
              <Select v-model="form.dutyCenter" @on-change="calculate">
                <Option v-for="depart in areaArr" :key="depart.id" :value="depart['name']">{{depart['name']}}</Option>
              </Select>
            </td>
            <td style="width:25%;text-align:center" rowspan="2">
              本期
            </td>
            <td style="width:25%;text-align:center" rowspan="2">
              上期
            </td>
          </tr>
          <tr>
            <td style="width:25%">
              时间段：
            </td>
            <td style="width:25%">
              <DatePicker
                type="daterange"
                placeholder="选择时间"
                style="width:100%"
                @on-change="selectdTime"
              ></DatePicker>
            </td>
          </tr>
          <tr>
            <td style="width:25%">
              上期实际使用资金：
            </td>
            <td style="width:25%" colspan="2">
              <Input v-model="form.lastbudget" ></Input>
            </td>
            <td style="width:25%" rowspan="3">
            </td>
          </tr>
          <tr>
            <td style="width:25%">
              上期账户余额：
            </td>
            <td style="width:25%" colspan="2">
              <Input v-model="form.lastBalances" ></Input>
            </td>
          </tr>
          <tr>
            <td style="width:25%">
              本期所需资金计划合计：
            </td>
            <td style="width:25%" colspan="2">
              <Input v-model="form.expenseTotal" :disabled="true"></Input>
            </td>
          </tr>
          <tr>
            <td style="width:25%" rowspan="5">专家费</td>
            <td style="width:25%">项目个数</td>
            <td style="width:25%">
              <Input v-model="form.projectTotal" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">采购预算</td>
            <td style="width:25%">
              <Input v-model="form.purchaseBudget" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">包组数量合计</td>
            <td style="width:25%">
              <Input v-model="form.groupTotal" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">专家费申请合计</td>
            <td style="width:25%">
              <Input v-model="form.expertFee" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">专家费-其他申请合计</td>
            <td style="width:25%">
              <Input v-model="form.expertOtherFee" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%" rowspan="2">业务招待费</td>
            <td style="width:25%">业务人员姓名</td>
            <td style="width:25%">
              <Input v-model="form.businessPeople" ></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">业务招待费计划合计</td>
            <td style="width:25%">
              <Input v-model="form.businessExpense" ></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%" rowspan="3">其他费用</td>
            <td style="width:25%">资金及费用类型</td>
            <td style="width:25%">
              <Select v-model="form.budgetType">
                <Option
                  v-for="item in expenseType"
                  :key="item"
                  :value="item"
                >{{item}}</Option>
              </Select>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">资金借支</td>
            <td style="width:25%">
              <Input v-model="form.palnningFunds" ></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">其他费用计划合计：</td>
            <td style="width:25%">
              <Input v-model="form.OtherFeeTotal" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%"></td>
            <td style="width:25%">本期实际需要申请资金计划</td>
            <td style="width:25%">
              <Input v-model="form.actualFundsPlan" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%"></td>
            <td style="width:25%">本期审批通过资金计划</td>
            <td style="width:25%">
              <Input v-model="form.actualFunds" ></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%"></td>
            <td style="width:25%">资金计划准确率：</td>
            <td style="width:25%">
              <Input v-model="form.accuracy" :disabled="true"></Input>
            </td>
            <td style="width:25%"></td>
          </tr>
          <tr>
            <td style="width:25%">备注：</td>
            <td style="width:25%" colspan="3">
              <Input v-model="form.remarks" ></Input>
            </td>
          </tr>
        </table>
      </Form>
    </Modal>
  </div>
</template>

<script>
import requestUrls from "@/lib/requestUrls"
import ajax from "@/lib/ajax"
import userAjax from "@/lib/userAjax"
import x2js from "x2js"
import inputSelect from '@/components/inputSelect'
import { add } from '@/lib/tool'

export default {
  components: {
    inputSelect
  },
  data() {
    return {
      columns: [
        {
          title: "责任中心",
          key: "dutyCenter",
          align: "center",
        },
        {
          title: "上期实际使用资金",
          key: "lastbudget",
          align: "center",
        },
        {
          title: "上期账户余额",
          key: "lastBalances",
          align: "center",
        },
        {
          title: "业务人员",
          key: "businessPeople",
          align: "center",
        },
        {
          title: "业务招待费",
          key: "businessExpense",
          align: "center",
        },
        {
          title: "资金及费用类型",
          key: "budgetType",
          align: "center",
        },
        {
          title: "资金借支",
          key: "palnningFunds",
          align: "center",
        },
        {
          title: "本期审批通过资金计划",
          key: "actualFunds",
          align: "center",
        },
      ],
      pageNum: 1,
      pageTotal: 0,
      pageSize: 10,
      purchaserData: [],
      areaArr: [],
      searchName: '',
      addPVisible: false,
      form: {
        dutyCenter: '',
        timeQuantum: '',
        lastbudget: '',
        lastBalances: '',
        totalBudget: '',
        businessPeople: '',
        businessExpense: '',
        palnningFunds: '',
        budgetType: '',
        actualFunds: '',
        remarks: '',
        expenseTotal: 0, // 本期所需资金合计
        projectTotal: 0, // 项目个数
        purchaseBudget: 0, // 采购预算
        groupTotal: 0, // 包组数量
        expertFee: 0, // 专家费合计
        expertOtherFee: 0, // 专家费其他合计
        OtherFeeTotal: 0, // 其他合计
        actualFundsPlan: 0, // 本期实际需要申请资金计划
        accuracy: '', // 准确率
      },
      tableData: [],
      expenseType: [
        '资金借支',
        '工资',
        '提成（提成奖金/项目奖金/管理奖金）',
        '社保',
        '住房公积金',
        '福利费',
        '教育经费',
        '工会经费',
        '办公费',
        '办公设备',
        '差旅费',
        '交通费',
        '车辆费用',
        '招待费',
        '招聘费',
        '租赁费',
        '水电费',
        '通讯费',
        '咨询费',
        '快递费',
        '维修费',
        '其他费用'
      ]
    }
  },
  // 得到第一页采购人数据
  async created() {
    // // 获取分公司信息
    let areaRep = await ajax.get(requestUrls.CLDistrict.GetList)
    this.areaArr = []
    if (areaRep.data.success && areaRep.data.result.items.length > 0) {
      this.areaArr = areaRep.data.result.items
    }
    this.getList()
  },
  computed: {
    lastBalances () {
      // this.form.lastBalances
      return add(parseInt(this.form.expertFee), parseInt(this.form.expertOtherFee), parseInt(form.businessExpense), parseInt(form.OtherFeeTotal))
    }
  },
  methods: {
    getList () {
      ajax.get(requestUrls.AbpFlowLog.GetPaged, {
        params: {
          filter: 'flowType == "双周计划"'
        }
      }).then(res => {
        const x2Json = new x2js()
        this.tableData = res.data.result.items.map(item => {
          return x2Json.xml2js(item.content).root
        })
      })
    },
    selectdTime (e) {
      this.form.timeQuantum = e
      this.calculate()
    },
    async calculate () {
      let rep = await ajax.get(requestUrls.AbpFlowLog.GetPaged, {
        params: {
          filter: `flowType == "专家费借支" and lastModificationTime > "${this.form.timeQuantum[0]}" and lastModificationTime < "${this.form.timeQuantum[1]}"`,
          district: this.form.dutyCenter || ''
        }
      })
      let rep2 = await ajax.get(requestUrls.AbpFlowLog.GetPaged, {
        params: {
          filter: `flowType == "专家费借支(其他)" and lastModificationTime > "${this.form.timeQuantum[0]}" and lastModificationTime < "${this.form.timeQuantum[1]}"`,
          district: this.form.dutyCenter || ''
        }
      })
      const x2Json = new x2js()
      this.form.projectTotal = rep.data.result.totalCount
      this.form.purchaseBudget = 0
      this.form.purchagroupTotalseBudget = 0
      this.form.groupTotal = 0
      this.form.expertFee = 0
      rep.data.result.items.forEach(item => {
        this.form.purchaseBudget += item.project.purchaseBudget
        this.form.groupTotal += item.project.groupCount
        let applyExpertForm = x2Json.xml2js(item.content).root.applyExpertForm
        this.form.expertFee += add(parseInt(applyExpertForm.buyer) * parseInt(applyExpertForm.buyerFee), 
                              parseInt(applyExpertForm.localExpert) * parseInt(applyExpertForm.localExpertFee),
                              parseInt(applyExpertForm.otherExpert) * parseInt(applyExpertForm.otherExpertFee),
                              parseInt(applyExpertForm.supervise) * parseInt(applyExpertForm.superviseFee),
                              parseInt(applyExpertForm.traffic) * parseInt(applyExpertForm.trafficFee),
                              parseInt(applyExpertForm.otherFee))
      })
      rep2.data.result.items.forEach(item => {
        let applyExpertForm2 = x2Json.xml2js(item.content).root.applyExpertForm
        this.form.expertOtherFee += add(parseInt(applyExpertForm.buyer) * parseInt(applyExpertForm.buyerFee), 
                              parseInt(applyExpertForm.localExpert) * parseInt(applyExpertForm.localExpertFee),
                              parseInt(applyExpertForm.otherExpert) * parseInt(applyExpertForm.otherExpertFee),
                              parseInt(applyExpertForm.supervise) * parseInt(applyExpertForm.superviseFee),
                              parseInt(applyExpertForm.traffic) * parseInt(applyExpertForm.trafficFee),
                              parseInt(applyExpertForm.otherFee))
      })
    },
    createPlan () {
      ajax.post(requestUrls.AbpFlowLog.CreateOrUpdate, {
        abpFlowLog: {
          // id: reviseFlowLog.id,
          contentJson: this.form,
          // projectId: this.selectProject.id,
          // reviewPerson: '结束',
          flowType: '双周计划',
          reviewStatus: 0,
          workFlowId: '',
          // fileId: reviseFlowLog.fileId,
          // fileName: reviseFlowLog.fileName,
        }
      }).then(res => {
        console.log(res)
      })
    },
    search () {
      
    },
    pageChange(pageNum) {
        this.getPurchaser("%"+this.searchName+"%",pageNum);
    },
    // tabChange (i) {
    //     this.currentIndex = i
    //     this.search()
    // },
    // // 搜索
    // search () {
    //     if (this.currentIndex === 0) {
    //         this.getPurchaser('%',1)
    //     } else {   // 报表查询
    //         let filiale = this.searchFiliale ? `&branch=${this.searchFiliale}` : ''
    //         let sysIndustry = this.searchSysIndustry ? `&hyxt=${this.searchSysIndustry}` : ""
    //         let purchase = this.searchName ? `&purchaseName=${this.searchName}` : ""
    //         let purchaseSite = this.searchPurchaseSite ? `&purchaseSite=${this.searchPurchaseSite}` : ""
    //         let contactMethod = this.searchContactMethod ? `&contactWay=${this.searchContactMethod}` : ""
    //         let contact = this.searchContact ? `&contactPerson=${this.searchContact}` : ""
    //         let assistant = this.searchAssistant ? `&khjl=${this.searchAssistant}` : ""
    //         let state = this.showOnly ? `&state=1` : "&state=0"
    //         this.reportSearch = filiale + sysIndustry + purchase + purchaseSite + contactMethod + contact + assistant + state
    //     }
    // },
  }
};
</script>

<style lang="less" scoped>
table td {
  padding: 4px;
  // border: 1px solid #ccc;
}
</style>